import { render, staticRenderFns } from "./NewsStories.vue?vue&type=template&id=bf01d780"
import script from "./NewsStories.ts?vue&type=script&lang=ts&external"
export * from "./NewsStories.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports